import { render, staticRenderFns } from "./carSelection.vue?vue&type=template&id=8cfb272a&scoped=true&"
import script from "./carSelection.vue?vue&type=script&lang=ts&"
export * from "./carSelection.vue?vue&type=script&lang=ts&"
import style0 from "./carSelection.vue?vue&type=style&index=0&id=8cfb272a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfb272a",
  null
  
)

export default component.exports